import axios, { CancelToken } from 'axios';
import qs from 'qs';
import { CellTowerDto, DeviceLastReportDto } from '@/features/map/types/devicesLastReport.types';
import { IconDto } from '@/features/map/types/map.dto';
import { ApiResult, Filter, ServiceResponse } from '@/OptimusRoutes/interfaces';
interface IMapService {
	getMapDevices(cancelToken?: CancelToken): Promise<DeviceLastReportDto[]>;
	getCellTower(): Promise<ServiceResponse<CellTowerDto[]>>;
	postGeolocation(cellTowers: CellTowerDto[]): Promise<ServiceResponse<CellTowerDto[]>>;
	getNearestDevices(latitude: number, longitude: number): Promise<ServiceResponse<DeviceLastReportDto[]>>;
	getIcons(filter: Filter<IconDto>, cancelToken?: CancelToken): Promise<ServiceResponse<ApiResult<IconDto[]>>>;
}

class Service implements IMapService {
	async getMapDevices(cancelToken?: CancelToken): Promise<DeviceLastReportDto[]> {
		const response = await axios.get<DeviceLastReportDto[]>('/v2/devices/map', { cancelToken });
		return response.data || [];
	}

	async getCellTower(): Promise<ServiceResponse<CellTowerDto[]>> {
		const { data } = await axios.get<ServiceResponse<CellTowerDto[]>>('/v2/cell-tower-triangulations');
		return data;
	}

	async postGeolocation(cellTowers: CellTowerDto[]): Promise<ServiceResponse<CellTowerDto[]>> {
		const { data } = await axios.post<ServiceResponse<CellTowerDto[]>>(
			'/v2/cell-tower-triangulations/geolocation',
			{
				cellTowers,
			}
		);
		return data;
	}

	async getNearestDevices(latitude: number, longitude: number): Promise<ServiceResponse<DeviceLastReportDto[]>> {
		const { data } = await axios.get<ServiceResponse<DeviceLastReportDto[]>>(
			`/v2/trackingHistory/nearest-devices/${latitude}/${longitude}`
		);
		return data;
	}

	async getIcons(
		{ filter }: Filter<IconDto>,
		cancelToken?: CancelToken
	): Promise<ServiceResponse<ApiResult<IconDto[]>>> {
		const params = { filter: JSON.stringify(filter) };
		const { data } = await axios.get<ServiceResponse<ApiResult<IconDto[]>>>(`/v2/icons?${qs.stringify(params)}`, {
			cancelToken,
		});
		return data;
	}
}

const MapService: IMapService = new Service();

export default MapService;
